import React from "react";
import VehiculeForm from "./VehiculeForm";

export default function VehiculeManagerPage() {
  return <VehiculeForm managerMode />;
}
